import { Skeleton } from "@mui/material";

const SkeletonLoader = ({ type }) => {
  const counts = {
    board: 5,
    "order-details": 10,
    "single-item": 1,
    calendar: 7 * 5,
  };

  const skeletonClass = {
    board: "skeleton-board-item",
    "order-details": "skeleton-order-item",
    "single-item": "skeleton-single-item",
    calendar: "skeleton-calendar-item",
  };

  return (
    <div className="skeleton-loader">
      {type === "calendar" ? (
        <div className="skeleton-calender-container">
          <Skeleton variant="rectangular" width="100%" height={40} />
          <div className="skeleton-calendar">
            {Array.from({ length: counts[type] }).map((_, index) => (
              <Skeleton key={index} variant="rounded" width={35} height={35} />
            ))}
          </div>
        </div>
      ) : (
        Array.from({ length: counts[type] }).map((_, index) => (
          <div key={index} className={skeletonClass[type]}></div>
        ))
      )}
    </div>
  );
};

export default SkeletonLoader;
